import { clsx } from 'clsx'
import { X } from 'lucide-react'
import { NavLink } from 'react-router'
import { StampIcon } from '@/components/ui/stamp-icon'
import { ICON_MAP, NAV_ITEMS } from '@/lib/nav-items'

interface MobileNavProps {
  open: boolean
  onClose: () => void
}

export function MobileNav({ open, onClose }: MobileNavProps): React.JSX.Element | null {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 lg:hidden">
      {/* biome-ignore lint/a11y/useSemanticElements: full-screen overlay backdrop, not a standard button */}
      <div
        role="button"
        tabIndex={0}
        aria-label="Close navigation"
        className="fixed inset-0 bg-black/50"
        onClick={onClose}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') onClose()
        }}
      />
      <div className="fixed inset-y-0 left-0 w-64 bg-surface-0 shadow-xl">
        <div className="flex h-16 items-center justify-between border-b border-surface-3 px-4">
          <div className="flex items-center gap-2">
            <StampIcon size={32} variant="solid" />
            <span className="text-lg font-semibold text-text-primary">One-Email</span>
          </div>
          <button type="button" onClick={onClose} className="rounded-lg p-1.5 hover:bg-surface-1">
            <X className="h-5 w-5 text-text-tertiary" />
          </button>
        </div>

        <nav className="space-y-1 p-3">
          {NAV_ITEMS.map((item) => {
            const Icon = ICON_MAP[item.icon]
            return (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/'}
                onClick={onClose}
                className={({ isActive }) =>
                  clsx(
                    'flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-brand-50 text-brand-700'
                      : 'text-text-secondary hover:bg-surface-1 hover:text-text-primary',
                  )
                }
              >
                <Icon className="h-5 w-5 shrink-0" />
                <span>{item.label}</span>
              </NavLink>
            )
          })}
        </nav>
      </div>
    </div>
  )
}
